import { numberWithDot } from 'helpers/utils';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';
import { memo } from 'react';
import { Link } from 'react-router-dom';

const SCREEN: DashboardScreen = 'recipients_dashboard';

interface PendingPayoutProps {
  className: string;
  payoutAmount: number;
  payoutDate: Date;
}

export const PendingPayout = memo(({ className, payoutAmount, payoutDate }: PendingPayoutProps) => {
  const formattedAmount = numberWithDot((payoutAmount / 100).toFixed(2));
  return (
    <div className={className}>
      <div className="card pending-payout-card">
        <div className="card-body recipients-card-content">
          <div className="payout-amount-container">
            <span
              className="payout-amount"
              aria-label={`Pending payout amount: $${formattedAmount}`}
            >
              ${formattedAmount}
            </span>
            <span className="oath-bodysmall">Pending Payout</span>
          </div>
          <div className="payout-details-container">
            <p className="oath-bodysmall">
              To be paid out on{' '}
              <strong>
                <em>
                  {payoutDate.toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </em>
              </strong>
              <br />
              Pending donations, ACH processing, and potential refunds may affect the final balance.
            </p>
            <p className="oath-bodysmall">
              To see recent payouts, click Payouts tab{' '}
              <Link
                to="/payouts"
                onClick={() => trackEvent('Payouts Link Clicked', { screen: SCREEN })}
              >
                here
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

PendingPayout.displayName = 'PendingPayout';
